import { render } from "./CostTypes.vue?vue&type=template&id=5e798d42"
import script from "./CostTypes.vue?vue&type=script&lang=ts"
export * from "./CostTypes.vue?vue&type=script&lang=ts"
script.render = render

export default script